import React, { useMemo } from "react";
import GenericTableFilter from "../../../../components/common/GenericTableFilter";

const OrderListFilters = ({
  filterFields,
  columns,
  handleApplyFilters,
  handleResetFilters
}) => {
  const initialFilters = useMemo(() => {
    const f = {};
    (filterFields || []).forEach(ff => (f[ff.field] = ""));
    return f;
  }, [filterFields]);

  return (
    <GenericTableFilter
      filterFields={filterFields}
      columns={columns}
      initialFilters={initialFilters}
      onSearch={() => {}}
      onApplyFilters={handleApplyFilters}
      onResetFilters={handleResetFilters}
      customFilterTypes={{}}       
      customFilterOptions={{}}
      initiallyOpen={true}
    />
  );
};

export default OrderListFilters;
